/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, FlexboxGrid, Table, Toggle, SelectPicker } from 'rsuite';

import { useDispatch, useSelector } from 'react-redux';
import { Container } from '~/styles/tabela1';
import { parseISO } from 'date-fns';

import SearchInputTable from '~/components/SearchInputTable';
import { InputDataRange } from '~/components/InputDataRange';
import { TablePagination, TableHeaderTooltip } from '~/components/TablePagination1';
import { toast } from 'react-toastify';
import { CelulaNotifcacao } from '~/components/CelulaNotificacao';
import CelulaAcao from '~/components/Celulas/components/CelulaAcao';
import moment from 'moment';
import EditarPedido from '../EditarPedido';
import { TogglesStatus } from './styles';
import api from '../../../services/api';
import PageHeader from '../../../components/PageHeader';
import Card from '../../../components/Card';

const { HeaderCell, Column, Cell } = Table;

function AlteracaoPedido() {
  const [pagina, setPagina] = useState(1);
  const [data, setData] = useState([]);
  const [textodigitado, setTextoDigitado] = useState('');
  const [pedido, setPedido] = useState('');
  const [registro, setRegistro] = useState('');
  const [pedidoEditando, setPedidoEditando] = useState();
  const [showEditarPedido, setShowEditarPedido] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [ajusteHorario, setAjusteHorario] = useState({
    lista: [],
    quantidade: 0,
  });
  const [filtrarStatus, setFiltrarStatus] = useState();
  const [orderBy, setOrderBy] = useState('order by id_pedido desc');

  const ajusteDeHorarioNaoLidos = useSelector(
    (state) => state.notificacao.ajusteDeHorarioNaoLidos
  );

  async function atualizarDadosPagina() {
    setCarregando(true);
    try {
      let dataInicio;
      let dataFim;
      if (data && data.length > 0) {
        dataInicio = data[0] !== null ? moment(data[0]).format('YYYY-MM-DD') : undefined;
        dataFim = data[1] !== null ? moment(data[1]).format('YYYY-MM-DD') : undefined;
      }
      const resposta = await api.get('ajustar-horario', {
        params: {
          status: filtrarStatus,
          pagina,
          pedido,
          registro,
          dataInicio: dataInicio !== null ? dataInicio : undefined,
          dataFim: dataFim !== null ? dataFim : undefined,
          orderBy
        },
      });
      const lista = resposta.data.lista.map((ped) => ({
        ...ped,
        numero_pedido: ped.id_pedido,
        numero_registro: `Ajuste de horário para o registro R-${ped.id_registro}`,
        data: moment(ped.created_at).format('DD/MM/YYYY | HH:mm'),
        data_servico: moment(ped.data_servico).format('DD/MM/YYYY'),
        status: ped.status,
      }));
      setAjusteHorario({
        lista,
        quantidade: resposta.data.quantidade,
      });
    } catch (error) {
      toast.error(error.message);
    }
    setCarregando(false);
  }

  useEffect(() => {
    if (ajusteHorario.quantidade > 0 && ajusteHorario.lista.length === 0) setPagina(1)
  }, [ajusteHorario.quantidade]);

  useEffect(() => {
    atualizarDadosPagina();
  }, [pagina, pedido, registro, data, ajusteDeHorarioNaoLidos, filtrarStatus, orderBy]);

  async function alteracaoStatus(e, value) {
    if (value === true) {
      atualizarDadosPagina();
      return;
    }
    try {
      const statusValue = {
        id: e.id,
        status: !value,
      };
      setCarregando(true);
      await api.patch(`ajustar-horario`, statusValue);
      setCarregando(false);
      atualizarDadosPagina();
      toast.success('Status atualizado com sucesso');
    } catch (error) {
      toast.error(error.message);
    }
  }

  const CelulaAcaoStatus = ({ rowData, ...props }) => (
    <Cell {...props}>
      <TogglesStatus>
        <Toggle
          checkedChildren="Resolvido"
          unCheckedChildren="Pendente"
          defaultChecked={rowData.status}
          onChange={() => alteracaoStatus(rowData, rowData.status)}
        />
      </TogglesStatus>
    </Cell>
  );

  function abrirEditarPedido(ped) {
    setPedidoEditando(ped);
    setShowEditarPedido(true);
  }

  function fecharEditarPedido() {
    setShowEditarPedido(false);
  }

  return (
    <Container>
      <PageHeader
        title="Ajuste de Horário"
        subtitle="Aqui você pode visualizar e gerenciar os ajustes de horário dos pedidos."
      />
      <Card>
        <FlexboxGrid align="middle" style={{ gap: '10px' }}>
          <SearchInputTable
            setTextoDigitado={setPedido}
            place="Pesquisar por Pedido"
            estilo={{ width: '220px' }}
          />
          <SearchInputTable
            setTextoDigitado={setRegistro}
            place="Pesquisar por Registro"
            estilo={{ width: '220px' }}
          />
          <InputDataRange
            ranges={[]}
            value={data}
            onChange={setData}
            onClean={() => setData([null, null])}
          />
          <SelectPicker
            name="status"
            value={filtrarStatus}
            searchable={false}
            placeholder="Status"
            data={[
              { label: 'Pendente', value: 'false' },
              { label: 'Resolvido', value: 'true' },
            ]}
            onChange={setFiltrarStatus}
          />
        </FlexboxGrid>
        <FlexboxGrid style={{ width: '100%', paddingTop: '20px' }}>
          <TablePagination
            carregando={carregando}
            dados={ajusteHorario.lista}
            quantidade={ajusteHorario.quantidade}
            onChangePage={setPagina}
            setOrderBy={setOrderBy}
          >
            <Column resizable width={60}>
              <HeaderCell>
                <TableHeaderTooltip label="Ação" tooltip="Ação" />
              </HeaderCell>
              <CelulaAcao
                dataKey="id_registro"
                onEditar={(ped) => {
                  abrirEditarPedido(ped);
                }}
              />
            </Column>
            <Column resizable width={105} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="N° Pedido" tooltip="N° Pedido" />
              </HeaderCell>
              <Cell dataKey="numero_pedido" />
            </Column>
            <Column resizable width={325}>
              <HeaderCell>
                <TableHeaderTooltip label="N° Registro" tooltip="N° Registro" />
              </HeaderCell>
              <Cell dataKey="numero_registro" />
            </Column>
            <Column resizable width={175} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Estabelecimento" tooltip="Estabelecimento" />
              </HeaderCell>
              <Cell dataKey="nome_fantasia" />
            </Column>
            <Column resizable width={170} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Função" tooltip="Função" />
              </HeaderCell>
              <Cell dataKey="profissao" />
            </Column>
            <Column resizable width={120} sortable>
              <HeaderCell>
                <TableHeaderTooltip label="Data Serviço" tooltip="Data Serviço" />
              </HeaderCell>
              <Cell dataKey="data_servico" />
            </Column>
            <Column resizable width={170}>
              <HeaderCell>
                <TableHeaderTooltip label="Data" tooltip="Data" />
              </HeaderCell>
              <Cell dataKey="data" />
            </Column>
            <Column resizable width={120}>
              <HeaderCell>
                <TableHeaderTooltip label="Status" tooltip="Status" />
              </HeaderCell>
              <CelulaAcaoStatus dataKey="status" />
            </Column>

          </TablePagination>
        </FlexboxGrid>
      </Card>
      <EditarPedido
        idPedido={pedidoEditando && pedidoEditando.id_pedido}
        showEditarPedido={showEditarPedido}
        codPedido={pedidoEditando && pedidoEditando.id_pedido}
        setShowEditarPedido={setShowEditarPedido}
        fecharEditarPedido={fecharEditarPedido}
      />
    </Container>
  );
}

export default AlteracaoPedido;
